import { FC } from "react";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { useNavigate } from "react-router-dom";
import DetailPagetLayout from "../Layout";
import GuestsInput from "./GuestsInput";
import GuestForm from "components/GuestForm/GuestForms";
import StayDatesRangeInputView from "./StayDatesRangeInputView";
import GuestsInputView from "./GuestsInputView";
import SectionHotelData from "../(components)/SectionHotelData";
import SectionGuestDistribution from "../(components)/SectionGuestDistribution";


const StayDetailPageContainer: FC<{}> = () => {

  const router = useNavigate();

  const renderSidebar = () => {
  
    const hotelCode = sessionStorage.getItem("selected_hotel") || "";
 
    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        {/* PRICE */}
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            Reserva:
            {/* <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /night
            </span> */}
          </span>
          {/* <StartRating /> */}
        </div>

        <SectionHotelData hotelCode={hotelCode}/>
        {/* FORM */}
        <form className="flex flex-col border border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <StayDatesRangeInputView className="flex-1 z-[11]" />
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          <GuestsInputView className="flex-1" />
          <div className="w-full border-b border-neutral-200 dark:border-neutral-700"></div>
          {/* datos de la distribucion de los huespedes */}
          <SectionGuestDistribution/>
        </form>

        {/* SUBMIT */}
        <button disabled={true} onClick={() => router('/checkout')} type="submit" className="bg-primary-6000 hover:bg-primary-6000 text-white py-2 px-4 rounded-full mt-4 w-full disabled:opacity-50">Reservar</button>
      </div>
    );
  }
  window.addEventListener('load', function () {
    document.getElementById('date-input')?.setAttribute('disabled', 'disabled');
    document.getElementById('guest-input')?.setAttribute('disabled', 'disabled');
  });

  const habitaciones = JSON.parse(sessionStorage.getItem('occupants') || "[]");
  return (
    <div className="nc-ListingStayDetailPage">

      {/* MAIN */}
      <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
        <div className="lg:hidden mb-4">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>

        {/* CONTENT */}
        <div className="w-full mb-20 lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">

          <GuestForm rooms={habitaciones} />

        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow lg:mt-0">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
      </main>
    </div>
  );
};

export default function ListingStayDetailPage() {
  return (
    <DetailPagetLayout>
      <StayDetailPageContainer />
    </DetailPagetLayout>
  );
}
